import type { SVGProps } from 'react';

const Slots = (props: SVGProps<SVGSVGElement>) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M2.50006 4C2.22392 4 2.00006 4.22386 2.00006 4.5C2.00006 4.77614 2.22392 5 2.50006 5H2.92356L2.00509 11.4293C1.96604 11.7027 2.15599 11.9559 2.42935 11.995C2.70272 12.034 2.95599 11.8441 2.99504 11.5707L3.97873 4.68485C4.03037 4.32339 3.74989 4 3.38476 4H2.50006Z"
            fill="currentColor"
        />
        <path
            d="M5.00006 4.5C5.00006 4.22386 5.22392 4 5.50006 4H6.38476C6.74989 4 7.03037 4.32339 6.97873 4.68485L5.99504 11.5707C5.95599 11.8441 5.70272 12.034 5.42935 11.995C5.15599 11.9559 4.96604 11.7027 5.00509 11.4293L5.92356 5H5.50006C5.22392 5 5.00006 4.77614 5.00006 4.5Z"
            fill="currentColor"
        />
        <path
            d="M8.50006 4C8.22392 4 8.00006 4.22386 8.00006 4.5C8.00006 4.77614 8.22392 5 8.50006 5H8.92356L8.00509 11.4293C7.96604 11.7027 8.15599 11.9559 8.42935 11.995C8.70272 12.034 8.95599 11.8441 8.99504 11.5707L9.97873 4.68485C10.0304 4.32339 9.74989 4 9.38476 4H8.50006Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 7V7.5H14.5V3.86622C14.2011 3.69331 14 3.37014 14 3C14 2.44772 14.4477 2 15 2C15.5523 2 16 2.44772 16 3C16 3.37014 15.7989 3.69331 15.5 3.86622V7.5C15.5 8.05228 15.0523 8.5 14.5 8.5H13V9C13 9.55228 12.5523 10 12 10V13C12 13.5523 11.5523 14 11 14H1C0.447715 14 0 13.5523 0 13V3C0 2.44772 0.447715 2 1 2H11C11.5523 2 12 2.44772 12 3V6C12.5523 6 13 6.44772 13 7ZM1 3H11V13H1L1 3Z"
            fill="currentColor"
        />
    </svg>
);

export default Slots;
